module.exports = __webpack_public_path__ + "static/media/artflow_ai.29798c8a.png";